// Banheiros: dois conjuntos no mesmo andar, masculino à esquerda e feminino à direita, com a
// área de pias em cima e as cabines em baixo. As divisórias de cabine formam a parede entre
// as portas. Piso de cerâmica branca.

import type { RoomMap } from '../../core/world.js';

export const BANHEIROS: RoomMap = {
  id: 'banheiros',
  kind: 'restroom',
  name: 'Banheiros',
  // b = cerâmica de banheiro
  floor: Array.from({ length: 9 }, () => 'bbbbbbbbbbbbbb'),
  legend: { b: 'ceramica-banheiro' },
  items: [
    // parede norte: espelhos sobre as pias, secador e relógio
    { item: 'poster-agzos', x: 0, y: 0 },
    { item: 'espelho-banheiro', x: 2, y: 0 },
    { item: 'espelho-banheiro', x: 4, y: 0 },
    { item: 'secador-maos', x: 6, y: 0 },
    { item: 'relogio', x: 7, y: 0 },
    { item: 'espelho-banheiro', x: 9, y: 0 },
    { item: 'espelho-banheiro', x: 11, y: 0 },
    { item: 'ar-condicionado', x: 12, y: 0 },
    // pias: duas para cada lado
    { item: 'pia-banheiro', x: 2, y: 1 },
    { item: 'pia-banheiro', x: 4, y: 1 },
    { item: 'pia-banheiro', x: 9, y: 1 },
    { item: 'pia-banheiro', x: 11, y: 1 },
    // cabines masculinas: divisória, vaso, divisória, vaso, divisória
    { item: 'divisoria-cabine', x: 0, y: 4 },
    { item: 'vaso-sanitario', x: 1, y: 4 },
    { item: 'divisoria-cabine', x: 2, y: 4 },
    { item: 'vaso-sanitario', x: 3, y: 4 },
    { item: 'divisoria-cabine', x: 4, y: 4 },
    // cabines femininas: mesmo arranjo
    { item: 'divisoria-cabine', x: 8, y: 4 },
    { item: 'vaso-sanitario', x: 9, y: 4 },
    { item: 'divisoria-cabine', x: 10, y: 4 },
    { item: 'vaso-sanitario', x: 11, y: 4 },
    { item: 'divisoria-cabine', x: 12, y: 4 },
    // canto de baixo: lixeira e planta
    { item: 'lixeira', x: 0, y: 7 },
    { item: 'planta-vaso', x: 13, y: 7 },
  ],
  doors: [{ x: 7, y: 8 }],
};
